import * as React from 'react';

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  componentDidCatch(error, info) {
    this.setState({ hasError: true });
    
    // logErrorToMyService(error, info);
  }

  render() {
    /*if (this.state.hasError) {
      return <h1>Something went wrong.</h1>;
    }*/
    return this.props.children;
  }
}



// WEBPACK FOOTER //
// ./src/components/ErrorBoundary.tsx